import React, { forwardRef } from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'sage' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  asChild?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  size = 'md',
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center gap-2 rounded-full font-body font-semibold transition-bounce relative overflow-hidden whitespace-nowrap active:scale-95 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-earth text-cream shadow-[0_4px_16px_rgba(44,24,16,0.2)] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(44,24,16,0.3)]',
    sage: 'bg-sage text-white shadow-sage hover:-translate-y-0.5 hover:bg-[#6a8e6e] hover:shadow-[0_12px_36px_rgba(122,158,126,0.35)]',
    outline: 'bg-transparent text-earth border-[1.5px] border-mist hover:bg-sand hover:border-stone',
    ghost: 'bg-transparent text-earth hover:bg-sand'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-7 py-3.5 text-[0.95rem]',
    lg: 'px-9 py-4.5 text-base'
  };
  return <button ref={ref} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} {...props} data-id="element-1159">
        {/* Hover overlay effect */}
        <span className="absolute inset-0 bg-white/0 hover:bg-white/10 transition-colors duration-300 pointer-events-none" data-id="element-1160" />
        {children}
      </button>;
});
Button.displayName = 'Button';